import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import {
  MDBContainer,
  MDBCol,
  MDBRow,
  MDBBtn,
  MDBInput,
  MDBCard,
  MDBCardBody,
  MDBCardHeader,
  MDBInputGroup,
  MDBDatepicker,
  MDBSelect,
  MDBDatatable,
  MDBIcon,
  MDBPopconfirm, MDBPopconfirmMessage,
  MDBModal, MDBModalDialog, MDBModalContent, MDBModalHeader, MDBModalTitle, MDBModalBody, MDBModalFooter,

} from 'mdb-react-ui-kit';
import Helper from '../Helper';
import Navbar from './sub/navbar';
import JobDetail from './sub/JobDetail';
import moment from 'moment';
import Alert from './sub/dialog'
import Search from './sub/search'
import Filter from './sub/filter'

import { Stack, Button, Radio, RadioGroup, FormControlLabel, FormControl, FormLabel } from '@mui/material';


const Component = () => {
  const navigate = useNavigate();

  const alert = useRef();
  const alertmodal = useRef();
  const editjob = useRef();
  const setError = (message) => alert.current.showerror(message);
  const [transportJobList, setTransportJobList] = useState([]);
  const [customers, SetCustomers] = useState([]);
  const [selectedrow, setSelectedRow] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [datatableKey, setDatatableKey] = useState(0); // Add a key state for MDBDatatable
  const [resultData, setResultData] = useState({
    columns: [
      { label: "เลขที่เอกสาร", field: 'name', sort: false },
      { label: "เลขที่ใบงาน", field: 'transportname', sort: false },
      { label: "วันที่ / เวลา", field: 'jobdate', sort: false },
      { label: "วันวางบิล", field: 'billdate', sort: false },
      { label: "วันครบกำหนด", field: 'duedate', sort: false },
      { label: "สถานะ", field: 'status', sort: false },
      { label: "ลูกค้า", field: 'customername', sort: false },

      { label: "ค่าเที่ยว", field: 'travel', sort: false },
      { label: "ค่าทางด่วน", field: 'toll', sort: false },
      { label: "ค่าปะยาง", field: 'tire', sort: false },
      { label: "ค่าฝากตู้", field: 'boxdeposit', sort: false },
      { label: "ซ่อมรถ", field: 'fixservice', sort: false },
      { label: "ค่าน้ำมัน", field: 'gas', sort: false },
      { label: "", field: 'action', sort: false },
            { label: "ผู้แก้ไขข้อมูล", field: 'modify_name', sort: false },

    ],
    rows: []
  });
  const [basicModal, setBasicModal] = useState(false);
  const toggleOpen = () => setBasicModal(!basicModal);


  const fetchTransportJobList_excel = async (dateFrom, dateTo, search) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/getTransportAccountList_expense_export`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${Helper.gettoken()}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ dateFrom, dateTo, search }),

      });

      if (response.ok) {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'Expenselist.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);
      } else {
        const data = await response.json();
        setError(data.message || 'Failed to export summary');
      }
    } catch (err) {
      setError('An error occurred while fexport summary.');
    }
  };

  const fetchTransportJobList = async (dateFrom, dateTo, search) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/getTransportAccountList_expense`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${Helper.gettoken()}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ dateFrom, dateTo, search }),

      });

      if (response.ok) {
        const data = await response.json();
        setTransportJobList(data.transportJobList);
      } else {
        const data = await response.json();
        setError(data.message || 'Failed to fetch transport list');
      }
    } catch (err) {
      setError('An error occurred while fetching the transport list.');
    }
  };

  const generateTree = (item) => {
    var main = item.map((row) => {
      return {
        ...row,
        jobdate: moment(row.jobdateobj).format("DD/MM/YYYY HH:mm"),
        duedate: row.duedateobj ? moment(row.duedateobj).format("DD/MM/YYYY") : "",
        billdate: row.billdateobj ? moment(row.billdateobj).format("DD/MM/YYYY") : "",
        action: (
          <>

            {/* <>   {row.transportname && <MDBBtn outline size='sm' floating className='call-btn' onClick={() => window.open('/TransportAccount/' + row.transportname, '_blank')}>
              {row.statusid != 3 ? <MDBIcon icon='pen' /> : <MDBIcon icon='eye' />}
            </MDBBtn>}
            </> */}
            <>   {<MDBBtn outline size='sm' floating className='call-btn' onClick={() => window.open('/TransportAccount_Expense/' + row.name, '_blank')}>
              {row.statusid != 3 ? <MDBIcon icon='pen' /> : <MDBIcon icon='eye' />}
            </MDBBtn>}
            </>
            <>   {row.transportname && <MDBBtn outline size='sm' rounded color='info' className='call-btn' onClick={() => window.open('/Print/ExpenseTawi50/' + row.name +'?personal=1', '_blank')}>
              <MDBIcon icon='print' />{" ทวิ 50 (บุคคล)"}
            </MDBBtn>}
            </>

          </>
        )

      }
    });



    var _resultData = {

      rows: main
    }

    _resultData.columns = [...resultData.columns];

    setResultData(_resultData);
    setDatatableKey((prevKey) => prevKey + 1);

  }
  useEffect(() => {

    generateTree(transportJobList);

  }, [transportJobList]);

  useEffect(() => {
    // Get the token from sessionStorage

    if (!["accountant", "billing", "admin"].includes(Helper.getuserrole())) {
      navigate('/main');
      return;
    }
    if (!Helper.gettoken()) {
      navigate('/login');
      return;
    }
    Helper.getCustomers(SetCustomers, setError);

    fetchTransportJobList(moment().format("YYYY-MM-DD"), moment().format("YYYY-MM-DD"));
  }, []);

  return (<>
    <Navbar />
    <MDBContainer fluid className="my-3">
      <Alert ref={alert} />

      <MDBRow className="justify-content-center">
        <MDBCol md="12">
          <MDBCard className="shadow-4 rounded-5">
            <MDBCardHeader>
              <MDBRow className='bg-body-tertiary d-flex align-items-center'>
                <MDBCol md='10'>
                  <h4>รายการบันทึกค่าใช้จ่าย</h4>
                </MDBCol>

              </MDBRow>


            </MDBCardHeader>
            <MDBCardBody>
              <Search search={fetchTransportJobList} exportexcel={fetchTransportJobList_excel} />
              <hr className="hr" />
              <Filter items={transportJobList} setitems={generateTree} status="statusid" duedate="duedateobj" hiddenopen={true} />

              <div className="mt-2">
                <MDBDatatable  hover key={datatableKey} data={resultData} rowsText="แสดง" noFoundMessage="ไม่มีข้อมูล" ofText="จาก" allText="ทั้งหมด" />
              </div>


            </MDBCardBody>

          </MDBCard>
        </MDBCol>
      </MDBRow>



    </MDBContainer>
  </>);
};

export default Component;
